import handleQueryError from '../../../../util/Common/Error/Handler/handleQueryError';
import safetyDefaultAPI from '../../api';

const getSpecificChassisData = async ({ seq }) => {
  try {
    const response = await safetyDefaultAPI.get(`chassis/${seq}`);
    return response;
  } catch (error) {
    throw new Error(handleQueryError({ error }));
  }
};

export default getSpecificChassisData;
